const TEST_CST = 3;
const config = {TEST_CST};

export default config;
